import { ReactNode } from 'react'
import PanelToolbar from './PanelToolbar'

interface PanelProps {
  title: string
  icon?: ReactNode
  children: ReactNode
  isMaximized?: boolean
  onMaximize?: () => void
  onClose?: () => void
  closeable?: boolean
  className?: string
  extra?: ReactNode
}

export default function Panel({
  title,
  icon,
  children,
  isMaximized,
  onMaximize,
  onClose,
  closeable = true,
  className = '',
  extra,
}: PanelProps) {
  return (
    <div className={`flex flex-col h-full bg-card overflow-hidden ${className}`}>
      <PanelToolbar
        title={title}
        icon={icon}
        isMaximized={isMaximized}
        onMaximize={onMaximize}
        onClose={onClose}
        closeable={closeable}
        extra={extra}
      />
      <div className="flex-1 overflow-hidden">
        {children}
      </div>
    </div>
  )
}
